export function formatNumber(num, locale) {
  return num.toLocaleString(locale);
}